import React from 'react'
import cx from 'classnames'
import { useIntl } from 'sb-react-intl'

import { Icon } from 'components/_new/ui'

import messages from './messages'
import s from './CloseIconButton.scss'


type CloseIconButtonColor = 'white' | 'brand' | 'black' | 'gray-70'

export type CloseIconButtonProps = {
  className?: string
  color?: CloseIconButtonColor
  ariaLabel?: string | ReactIntlMessage
  withRemoveLabel?: boolean
  dataTestId?: string
  onClick: React.MouseEventHandler<HTMLButtonElement>
}

const CloseIconButton: React.FunctionComponent<CloseIconButtonProps> = (props) => {
  const { className, withRemoveLabel, ariaLabel, color, dataTestId, onClick } = props

  const intl = useIntl()
  const label = intl.message(ariaLabel || (withRemoveLabel ? messages.remove : messages.close))

  return (
    <button
      className={cx(s.button, className)}
      type="button"
      aria-label={label}
      data-testid={dataTestId}
      onClick={onClick}
    >
      <Icon name="close" color={color} noWrapper />
    </button>
  )
}


export default React.memo(CloseIconButton)
